//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../Mechatronics/Mechatronics.ComparisonResultBase.js";
let d=[[[0,"ComparisonStatus",0,0],[0,"PartNumber",0,0]],[[[],"Dispose",{},0,0],[["numAttributes","attributeNames","attributeValues"],"GetAttributes",{},0,0]],[]];
SPLM.Mechatronics.ComparisonResultElectricalPart = class extends SPLM.Mechatronics.ComparisonResultBase{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.ComparisonResultElectricalPart";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.ComparisonResultElectricalPart.Status = Object.freeze({
    "Added" : "Added", "Removed" : "Removed", "Updated" : "Updated", "Identical" : "Identical"});

export default SPLM;